
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

interface AddAdminFormProps {
  email: string
  onEmailChange: (email: string) => void
  onSubmit: (e: React.FormEvent) => void
}

export const AddAdminForm = ({ email, onEmailChange, onSubmit }: AddAdminFormProps) => {
  return (
    <form onSubmit={onSubmit} className="flex gap-4 items-end">
      <div className="space-y-2 flex-1">
        <label htmlFor="email" className="text-sm font-medium">
          Add New Admin
        </label>
        <Input
          id="email"
          type="email"
          placeholder="Enter email address"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          required
        />
      </div>
      <Button type="submit">Add Admin</Button>
    </form>
  )
}
